import useDashboardUrlCondition from 'components/Dashboard/Navigation/useDashboardUrlCondition';

const getAppSite = () => {
  switch (import.meta.env.VITE_APP_SITE) {
    case 'PolicyMogulUSA':
      return 'usa';
    default:
      return 'global';
  }
};

const useSiteSectionsNames = () => {
  const { showDashboard } = useDashboardUrlCondition();
  const names = [
    {
      global: 'Parliamentary record',
      usa: 'Congressional Record',
    },
    {
      global: 'Spoken parliamentary contributions',
      usa: 'Congressional Record contributions',
    },
    { global: 'Key updates', usa: 'News releases', special: 'Latest news' },
    { global: 'Priority  updates' },
    { global: 'Key update', usa: 'News' },
    { global: 'Official records', usa: 'Congressional Records' },
    { global: 'Committee publications', usa: 'Regulations' },
    { global: 'Colour', usa: 'Color' },
    { global: 'Mentions', usa: 'Congressional mentions' },
    { global: 'Parliamentary contribution', usa: 'Congressional contributions' },
    { global: 'Analyse', usa: 'Analyze' },
    { global: 'optimised', usa: 'optimized' },
    { global: 'organisation', usa: 'organization' },
    { global: 'customise', usa: 'customize' },
    { hiddenName: 'Tweets', global: 'X posts', usa: 'X posts' },
    { hiddenName: 'Retweets', global: 'X reposts', usa: 'X reposts' },
    { hiddenName: 'Social media', global: 'X posts', usa: 'X posts' },
  ];

  const getName = ({ property, plural, uppercase }) => {
    if (!property) return '';
    const isFirstCharUpperCase = property[0] === property[0].toUpperCase();

    // Helper function to get singular form
    const getSingular = (word) => {
      if (word.endsWith('ies')) return word.slice(0, -3) + 'y';
      if (word.endsWith('s') && word.length > 3) return word.slice(0, -1);
      return word;
    };

    // Helper function to get plural form
    const getPlural = (word) => {
      if (word.endsWith('y')) return word.slice(0, -1) + 'ies';
      if (!word.endsWith('s')) return word + 's';
      return word;
    };

    const propertyLower = property?.toLowerCase();
    const propertySingular = getSingular(propertyLower);
    const propertyPlural = getPlural(propertyLower);

    // Find item by checking both original, singular, and plural forms
    const item = names.find((item) => {
      const globalLower = item?.global?.toLowerCase();
      const hiddenNameLower = item?.hiddenName?.toLowerCase();
      return (
        globalLower === propertyLower ||
        globalLower === propertySingular ||
        globalLower === propertyPlural ||
        hiddenNameLower === propertyLower ||
        hiddenNameLower === propertySingular ||
        hiddenNameLower === propertyPlural
      );
    });
    let result = showDashboard
      ? (item?.['special'] ?? item?.[getAppSite()] ?? property)
      : (item?.[getAppSite()] ?? property);

    // Apply plural transformation if requested
    if (plural !== undefined) {
      const resultLower = result.toLowerCase();
      if (plural) {
        result = getPlural(resultLower);
      } else {
        result = getSingular(resultLower);
      }
    }

    // Apply case transformation
    if (uppercase !== undefined) {
      if (uppercase) {
        result = result.toUpperCase();
      } else {
        result = result.toLowerCase();
      }
    } else {
      // Preserve original case behavior if uppercase prop not provided
      result = isFirstCharUpperCase
        ? result.charAt(0).toUpperCase() + result.slice(1)
        : result.charAt(0).toLowerCase() + result.slice(1);
    }
    return result;
  };
  const getTopicTitle = (title) => {
    if (title?.startsWith('All updates') && showDashboard) {
      return title.replace('All updates', 'All topics');
    }
    return title;
  };

  return { getName, getTopicTitle };
};

const comprehensiveText = (props) => {
  const { uppercase } = props ?? {};
  return getAppSite() === 'usa'
    ? `${uppercase ? 'C' : 'c'}omprehensive`
    : `${uppercase ? 'T' : 't'}he UK’s most comprehensive`;
};

const currencySymbol = getAppSite() === 'usa' ? '$' : '£';

export { useSiteSectionsNames, comprehensiveText, currencySymbol };
export default getAppSite;
